import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import {
  showError,
  showSuccess,
} from '../../0_presentation/core/components/feedback/snackbar';
import { Clinic } from '../../2_domain/clinic/clinic';
import IClinicRepository from '../../2_domain/clinic/iClinicRepository';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

const useClinicInformationPageController = (clinic: Clinic) => {
  const clinicRepo = Get.find<IClinicRepository>('IClinicRepository');

  const theme = useTheme();
  const navi = useNavigate();

  const [clinicName, setClinicName] = useState(clinic.name);
  const [ceoName, setCeoName] = useState(clinic.ceoName);
  const [phone, setPhone] = useState(clinic.phone);
  const [email, setEmail] = useState(clinic.email);
  const [website, setWebsite] = useState(clinic.website ?? '');
  const [fax, setFax] = useState(clinic.fax ?? '');
  const [streetAddress, setStreetAddress] = useState(clinic.streetAddress);
  const [additionalAddress, setAdditionalAddress] = useState(
    clinic.additionalAddress ?? ''
  );
  const [city, setCity] = useState(clinic.city);
  const [zip, setZip] = useState(clinic.zip);

  const onSaveHandler = async () => {
    await promiseResolver({
      promise: clinicRepo.updateClinicInformation({
        name: clinicName,
        ceo: ceoName,
        apt: additionalAddress,
        streetAddress: streetAddress,
        city: city,
        zipCode: zip,
        phone: phone,
        web: website,
        fax: fax,
      }),
      successCallback: () => {
        navi(0);
        showSuccess(theme.texts.updateSuccess);
      },
      errorCallback: (err) => {
        showError(err);
      },
    });
  };

  return {
    clinic,
    clinicName,
    setClinicName,
    ceoName,
    setCeoName,
    phone,
    setPhone,
    email,
    setEmail,
    website,
    setWebsite,
    fax,
    setFax,
    streetAddress,
    setStreetAddress,
    additionalAddress,
    setAdditionalAddress,
    city,
    setCity,
    zip,
    setZip,
    onSaveHandler,
  };
};

export default useClinicInformationPageController;
